import React, { useState } from "react";
import getModalStyle from "../../../../util/getModalStyle";

function useEmailWarningSelector(handleOpenEmailModal: () => void) {
  const [modalStyle] = useState(() => getModalStyle(50, 50));

  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === "Enter") {
      return handleOpenEmailModal();
    }
  };

  return {
    handleKeyDown,
    modalStyle,
  };
}

export default useEmailWarningSelector;
